export default {
    HEART: 1,
    FLANDRE: {
        WIDTH: 150,
        HEIGHT: 150,
        STEP: 15,
        SLOW_STEP: 5
    },
    MESS_STEP: 55,
    MESS_TIME_GAP: 3,
    AIM_PREFIX: 50,
    MAX_LEVEL: 1
}
